module.exports = __webpack_public_path__ + "img/器皿柜.adc00d8a.jpg";